(function () {

const drawer = document.getElementById("QuickAddDrawer");

if (!drawer) return;

const overlay = drawer.querySelector(".quick-add-overlay");
const closeBtn = drawer.querySelector(".quick-add-close");

const loading = drawer.querySelector(".quick-add-loading");
const productBox = drawer.querySelector(".quick-add-product");

let currentProduct = null;

/*----------------------------------
Open Drawer
-----------------------------------*/

function openDrawer() {
  drawer.classList.add("active");
  document.body.classList.add("quick-add-open");
}

/*----------------------------------
Close Drawer
-----------------------------------*/

function closeDrawer() {
  drawer.classList.remove("active");
  document.body.classList.remove("quick-add-open");

  loading.style.display = "block";
  productBox.hidden = true;
}

overlay.addEventListener("click", closeDrawer);
closeBtn.addEventListener("click", closeDrawer);

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    closeDrawer();
  }
});

/*----------------------------------
Fetch Product
-----------------------------------*/

async function loadProduct(handle) {

  loading.style.display = "block";
  productBox.hidden = true;

  openDrawer();

  try {

    const response = await fetch("/products/" + handle + ".js");

    if (!response.ok) {
      throw new Error("Unable to load product.");
    }

    currentProduct = await response.json();

    loading.style.display = "none";
    productBox.hidden = false;

    // Part 2
    renderQuickAdd(currentProduct);

  } catch (err) {

    loading.innerHTML =
      "<p>Unable to load product.</p>";

    console.error(err);

  }

}

/*----------------------------------
Quick Add Buttons
-----------------------------------*/

document.addEventListener("click", function (e) {
  const btn = e.target.closest("[data-open-product]");
  if (!btn) return;
  e.preventDefault();
  loadProduct(btn.dataset.handle);
});

/*----------------------------------
Expose globally
-----------------------------------*/

window.QuickAdd = {
  drawer,
  closeDrawer,
  loadProduct,
  getProduct() {
    return currentProduct;
  }

};

})();

/*====================================================
PART 2
Render Product
====================================================*/

function moneyFormat(cents) {
  if (window.Shopify && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, window.theme?.moneyFormat || "{{amount}}");
  }
  return "$" + (cents / 100).toFixed(2);
}

function renderQuickAdd(product) {

    document.getElementById("qaTitle").textContent = product.title;

    document.getElementById("qaImage").src =
        product.featured_image;

    document.getElementById("qaImage").alt =
        product.title;

    const firstVariant = product.variants.find(v => v.available) || product.variants[0];

    updateHeader(firstVariant);

    document.getElementById("QuickAddVariant").value =
        firstVariant.id;

    const wrapper =
        document.getElementById("QuickAddOptions");

    wrapper.innerHTML = "";

    product.options.forEach(function(option, index) {

      const optionName = option.name;

      const values = option.values;

      let html = `
          <div class="quick-add-option">
              <h4>${optionName}</h4>
              <div class="quick-add-values" data-option-index="${index}">
      `;

      values.forEach(function(value, i) {

          html += `
              <label>
                  <input
                      type="radio"
                      name="option-${index}"
                      value="${value}"
                      ${i === 0 ? "checked" : ""}
                  >
                  <span>${value}</span>
              </label>
          `;

      });

      html += `
              </div>
          </div>
      `;

      wrapper.insertAdjacentHTML("beforeend", html);

  });

    bindOptionEvents(product);

}

/*====================================================
Update Header
====================================================*/

function updateHeader(variant){

    document.getElementById("qaPrice").innerHTML =
        moneyFormat(variant.price);

    const compare =
        document.getElementById("qaComparePrice");

    if(
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
    ){

        compare.innerHTML =
            moneyFormat(variant.compare_at_price);

        compare.style.display="inline";

    }else{

        compare.style.display="none";

    }

    if(variant.featured_image){

        document.getElementById("qaImage").src =
            variant.featured_image.src;

    }

}

/*====================================================
PART 3
Variant Selection
====================================================*/

function getSelectedOptions(product) {
  const selected = [];
  product.options.forEach(function(option, index) {
    const input = document.querySelector(
      'input[name="option-' + index + '"]:checked'
    );
    selected.push(input ? input.value : "");
  });
  return selected;

}

function findVariant(product) {

    const selected = getSelectedOptions(product);

    return product.variants.find(function(variant) {

        return variant.options.every(function(value, index) {
            return value === selected[index];
        });

    });

}

function updateVariant(product) {

    const variant = findVariant(product);

    const submit = document.getElementById("QuickAddSubmit");

    if (!variant) {

        submit.disabled = true;
        submit.innerHTML = window.QuickAddStrings.unavailable;

        return;

    }

    document.getElementById("QuickAddVariant").value = variant.id;

    updateHeader(variant);

    if (variant.available) {

        submit.disabled = false;
        submit.innerHTML = window.QuickAddStrings.addToCart;

    } else {

        submit.disabled = true;
        submit.innerHTML = window.QuickAddStrings.soldOut;

    }

    updateAvailability(product);

}

/*====================================================
Disable Impossible Options
====================================================*/

function updateAvailability(product) {

    product.options.forEach(function(option, optionIndex) {

        const radios = document.querySelectorAll(
            'input[name="option-' + optionIndex + '"]'
        );

        radios.forEach(function(radio) {

            const current = getSelectedOptions(product);

            current[optionIndex] = radio.value;

            const exists = product.variants.some(function(variant) {

                if (!variant.available) return false;

                return variant.options.every(function(value, i) {
                    return value === current[i];
                });

            });

            radio.disabled = !exists;

        });

    });

}

/*====================================================
Bind Events
====================================================*/

function bindOptionEvents(product) {

    const radios = document.querySelectorAll(
        '#QuickAddOptions input[type="radio"]'
    );

    radios.forEach(function(radio) {

        radio.addEventListener("change", function() {

            updateVariant(product);

        });

    });

    updateVariant(product);

}

/*====================================================
PART 4
AJAX Add To Cart
====================================================*/
document.addEventListener("submit", async function (e) {

    if (!e.target.matches("#QuickAddForm")) return;

    e.preventDefault();

    const btn = document.getElementById("QuickAddSubmit");
    const variantId = document.getElementById("QuickAddVariant").value;

    if (!variantId) {
        alert("Please select a variant");
        return;
    }

    btn.disabled = true;

    try {

      const form = $('<form></form>');

      form.append(
          $('<input>', {
              type: 'hidden',
              name: 'id',
              value: variantId
          })
      );

      form.append(
          $('<input>', {
              type: 'hidden',
              name: 'quantity',
              value: 1
          })
      );

      theme.partials.Cart.addItem(form, function(success, error) {

          if (!success) {
              alert(error || "Unable to add product.");
              btn.disabled = false;
              return;
          }

          theme.partials.Cart.updateAllHtml(function() {

              QuickAdd.closeDrawer();

              $('[data-off-canvas--open="right-sidebar"]')
                  .first()
                  .trigger('click');

              btn.innerHTML = "✓ Added";

              setTimeout(function() {

                  btn.innerHTML = "ADD TO CART";
                  btn.disabled = false;

              }, 500);

          });

      });

  } catch (err) {

      console.log(err);

      alert(err.description || err.message || "Unable to add product.");

      btn.disabled = false;

  }

});